import "../styles/DashboardStyles.css";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { LocalStorage } from "../../../utils/Utils";
import { useApi } from "../../../service/ApiContext";
import { fetchSyncDashboard } from "../../../service/DashboardSyncService";
import Loader from "../../../utils/Utils";
import Logger from "../../../utils/Logger";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { logActionEvent } from "../../../analytics/analytics_utils";
import analytics_strings from "../../../analytics/analytics_strings";
import { setLoading } from "../data/redux/LoginReducer";
import sandClockStart from "../assets/sandClockStart.png";
import sandClockEnd from "../assets/sandClockEnd.png";
import calendar from "../assets/calendar.png";
import clockImg from "../assets/clock.png";
import closeIcon from "../assets/closeIcon.png";
import arrowImg from "../assets/btnArrowImg.png";
import blueArrow from "../assets/blueArrow.png";
import arrow from "../assets/arrow.png";
import LevelUpEngagementComponent from "../components/LevelupEngagement";
import CommonUtils from "../../../utils/Common_Utils";
import {
  setIsGradedQuiz,
  setSelectedToggle,
  setHasJozunaSkills,
} from "../data/redux/GradedPopQuizRedux";

import ImT from "../assets/IMT.png";
import { setPrograms } from "../../calender/data/redux/reducer/ProgramDetailReducer";
import lifecareer from "../assets/life&career.png";
import interdisiplinary from "../assets/interdisiplinary.png";
import learningnnovation from "../assets/learning&innovation.png";
import OverallProgressListPendingItems from "../components/OverallProgressListPendingItems";
import activeStar from "../assets/star 2.svg";
import inactiveStar from "../assets/star 3.svg";
import V2StarDropdown from "../components/StarDropdownComponent";
import motivationIcon from "../assets/motivationIcon.svg";
import notificationIcon from "../assets/notificationIcon.svg";
import noNotificationIcon from "../assets/NoNotification.svg";

import cancelIcon from "../assets/cancelIcon.svg";
import faqIcon from "../assets/faqIcon.svg";
import notifyCancel from "../assets/notifyCancel.svg";
import DashboardNeedHelp from "../components/DashboardNeedHelp";
import rightArrow from "../assets/arrowright.svg";
import streakImg from "../assets/star 4.svg";
import fire from "../assets/fire.svg";
import MessageIcon from "../assets/messageIcon.png";
import TestPadIcon from "../assets/testpadIcon.png";
import SessionIcon from "../assets/sessionIcon.png";
import PlayIcon from "../assets/playIcon.png";
import OverallAssessmentStart from "../assets/overallAssessmentStart.svg";
import OverallVideoWatch from "../assets/learningImg.png";
import NoVideosImg from "../assets/pdfandvideoillustrator.png";
import ActiveAssessmentImg from "../assets/activeAssessment.svg";
import MissedAssessmentImg from "../assets/activeAssessment.svg";
import AllVideosWatchedImg from "../assets/pdfandvideoallwatchedimg.png";
import GreatNoAssessmentImg from "../assets/noMissedAssessment.svg";
import CompletedAllAssImg from "../assets/completedAllAssessment.svg";
import viewAllArrow from "../assets/viewAllArrow.svg";
import emptyAssessmentImg from "../assets/emptyAsssess.svg";
import emptyLearningImg from "../assets/emptyLearnings.svg";
import certificateIcon from "../../../assets/images/certificates/Property 1=Default.svg";
import viewCertificateIcon from "../../../assets/images/certificates/Certificate.svg";

import {
  NotificationData,
  NotificationItem,
} from "../data/interface/AddQueryInterface";
import ShimmerLoader from "../components/ShimmerLoader";
import FileIcon from "../assets/fileIcon.png";

import {
  AssessmentResponse,
  SubscriptionResponse,
  TopicVideoResponse,
  VideoResponse,
} from "../data/interface/PendingItemsInteface";
import TruncatedTextWithTooltip from "../components/TruncatedTooltip";
import RecommendationIndustryViewClient, {
  AssessmentQuestionModuleClient,
  VideoReportClient,
} from "../data/client/VideoReportClient";
import strings from "../../../utils/Strings";
import { LabSessionVideoResponse } from "../data/interface/Topic_video_response";
import {
  setAssessmentId,
  setCurrentCounter,
  setDuration,
  setIsIndependent,
  setStatus,
  setTimeSpend,
  setTotalQuestion,
} from "../data/redux/AssessmentSlice";
import { useAlert } from "../../../components/AlertContextComponent";
import {
  StreakUpResponse,
  StreakUpUIResponse,
} from "../data/interface/StreakUpResponse";
import MiniCalendar from "../components/MiniCalendar";
import CardBottomOverlay from "../components/CardBottomOverlay";
import feedbackMessageIcon from "../assets/feedbackMessageIcon.svg";
import viewAllFeedback from "../assets/whiteFeedbackArrow.svg";
import {
  FeedbackItem,
  renderFeedbackMessage,
} from "../../../components/FeedbackMessageRenderer";
import { Tooltip } from "@mui/material";
import { ChevronLeft, ChevronRight } from "lucide-react";
import infoImg from "../assets/info.png";

const items = [
  { label: "Completed a Learning Content", completed: true },
  { label: "Completed a Assessment", completed: false },
  { label: "Completed a Pop-Quiz", completed: false },
];

interface FeedbackResponse {
  number_of_records: number;
  feedback: FeedbackItem[];
}

const EmptyEngagementPlaceholder = () => (
  <div className="v2-dash-engagement-placeholder">
    <span style={{ fontFamily: "Mazzard", fontSize: "12px" }}>
      * We will notify if any content is added in your learning room
    </span>
  </div>
);

const motivationalTexts = [
  "Small progress is still progress. Keep going.",
  "Learn today; your future self will thank you.",
  "Consistency beats intensity. Show up every day.",
  "You don’t have to be perfect. You just have to start.",
  "Every expert was once a beginner.",
  "Start where you are. Use what you have.",
  "Your only limit is your next excuse.",
  "Focus on progress, not perfection.",
  "Make today count.",
  "Mistakes are proof that you are trying.",
  "Challenge yourself, not others.",
  "Growth begins at the end of your comfort zone.",
  "Struggle is part of the learning process.",
  "Keep learning, keep growing.",
  "The more you learn, the more you earn.",
  "Discipline today, freedom tomorrow.",
  "Push yourself. No one else will do it for you.",
  "Dream it. Learn it. Achieve it.",
  "Your future is built one lesson at a time.",
  "Progress starts with showing up.",
  "Every click brings you closer to mastery.",
  "Keep learning. Keep evolving.",
  "Success begins with consistency.",
  "Small daily improvements create big results.",
  "Stay curious. Stay unstoppable.",
  "One lesson today, endless opportunities tomorrow.",
  "Growth happens when you keep going.",
  "Every expert once struggled too.",
  "The journey of learning never goes to waste.",
  "Knowledge is your greatest advantage.",
  "Don’t stop now — you’re improving.",
  "Learning is the shortcut to confidence.",
  "Push forward, even one step at a time.",
  "Discipline turns goals into achievements.",
  "Great things take time — keep learning.",
  "Questions today become confidence tomorrow.",
  "Every lesson adds to your potential.",
  "Learning unlocks new possibilities.",
  "Your dedication is your superpower.",
  "Mistakes are part of mastering.",
  "Believe in your growth.",
  "Study with purpose.",
  "Every learning is a step forward.",
  "Your future self is cheering for you.",
  "Consistency creates excellence.",
  "Never stop learning.",
  "Stay consistent.",
  "One step daily.",
  "Keep building.",
  "Learn. Apply. Grow.",
];

const cardDetails = [
  {
    title: "Master the Assessments",
    desc: "Keep ahead by completing your assessments on time.",
    button: "Take Assessment",
    bg: "#FFF6D8",
    icon: TestPadIcon,
  },
  {
    title: "Conquer the Video Library",
    desc: "Aim for 100% completion on a module this week.",
    button: "Go to Learning room",
    bg: "#DFF2FF",
    icon: PlayIcon,
  },
  // {
  //   title: "Become a Forum Sage",
  //   desc: "Share wisdom or ask a great question in the forums.",
  //   button: "Add Query",
  //   bg: "#D2FCFB",
  //   icon: MessageIcon,
  // },
  // {
  //   title: "Ace Your Attendance",
  //   desc: "Join live sessions to connect with instructors.",
  //   button: "Join Live Sessions",
  //   bg: "#F8EAFF",
  //   icon: SessionIcon,
  // },
];

interface DomainScore {
  domain_id: string;
  domain_name: string;
  score: number;
  progress: number;
  is_graded: boolean;
  is_assessment: boolean;
}
interface EngagementScore {
  top: number;
  max: number;
  score: number;
}

export interface ApiResponse {
  candidate_id: string;
  institute_id: string;
  overall_progress: number;
  jozuna_score: DomainScore[];
  curriculum_score: DomainScore[];
  industry_score: DomainScore[];
  engagement_score: EngagementScore;
  is_graded_quiz?: boolean;
}

interface PendingItem {
  id: string;
  topic_id?: string;
  course_id?: string;
  program_id?: string;
  type: "video" | "assessment";
  title: string;
  action: string;
  status?: "active" | "missed";
  assessment_entity_id?: string;
  assessment_id?: string | null;
  current_counter?: number | null;
  time_spend?: number | null;
  total_question?: number | null;
  assessment_duration?: number | null;
  candidate_assessment_status?: string | null;
  program_category?: "Jozuna" | "Industry";
  is_lab_session?: boolean;
  image?: string;
  assessment_expiry?: string;
  // content_type?: string;
  // program_name?: string;
  // course_name?: string;
  // topic_name?: string;
  assessment_start_time?: string;
  file_title?: string;
  assessment_entity_name?: string;
  dimension_questions?: boolean;
  category_questions?: boolean;
  curriculum_questions?: boolean;
  assessment_entity_time_left?: string;
  category_list?: any[];
  curriculum_list?: any[];
}
interface EventItem {
  id: number;
  courseName: string;
  eventName: string;
  startDate: string;
  endDate: string;
  type: "yellow" | "purple";
  action: "Start" | "Join";
}
const DashboardPage = () => {
  const [events, setEvents] = useState<EventItem[]>([]);
  const [showAll, setShowAll] = useState(false);
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  // const [selectedToggle, setSelectedToggle] = useState("Progress Timeline");
  const selectedToggle = useSelector(
    (state: RootState) => state.advancedFilterGradedPopQuiz.selectedToggle,
  );

  const dispatch = useDispatch();
  const listProgramData = useSelector(
    (state: RootState) => state.programs.programs,
  );
  const [apiData, setApiData] = useState<ApiResponse | null>(null);
  const [streakData, setStreakData] = useState<StreakUpUIResponse | null>(null);
  const [activeTab, setActiveTab] = useState<
    "jozuna" | "curriculum" | "industry"
  >("curriculum");

  useEffect(() => {
    if (!apiData) return;

    const curriculumCount =
      (apiData.curriculum_score?.length ?? 0) +
      apiData.industry_score.filter((item) => item.is_graded === false).length;

    const professionalCount = apiData.industry_score.filter(
      (item) => item.is_graded === true,
    ).length;

    if ((apiData.jozuna_score?.length ?? 0) > 0) {
      setActiveTab("jozuna");
    } else if (curriculumCount > 0) {
      setActiveTab("curriculum");
    } else if (professionalCount > 0) {
      setActiveTab("industry");
    }
  }, [apiData]);
  const navigate = useNavigate();
  // ---- inside your component ----
  const curriculumRef = useRef<HTMLDivElement | null>(null);
  const industryRef = useRef<HTMLDivElement | null>(null);
  const jozunaRef = useRef<HTMLDivElement | null>(null);
  const [isLevelOpen, setIsLevelOpen] = useState<boolean>(false);
  const [showCurriculumArrows, setShowCurriculumArrows] = useState(false);
  const [showIndustryArrows, setShowIndustryArrows] = useState(false);
  const [showJozunaArrows, setShowJozunaArrows] = useState(false);
  const [openOverLay, setOpenOverlay] = useState(false);
  const [assessmentClicked, setAssessmentClicked] = useState<boolean>(false);
  const [feedbackOpenOverLay, setFeedbackOpenOverLay] = useState(false);

  const getCurrentData = () => {
    if (!apiData) return [];

    switch (activeTab) {
      case "jozuna":
        return apiData.jozuna_score;
      case "curriculum":
        return [
          ...apiData.curriculum_score,
          // ...apiData.industry_score.filter((item) => item.is_graded === false),
        ];
      case "industry":
        // return apiData.industry_score.filter((item) => item.is_graded === true);
        return apiData.industry_score;
      default:
        return [];
    }
  };
  // curriculum scroll handlers
  const scrollCurriculumLeft = () => {
    if (curriculumRef.current) {
      curriculumRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };
  const scrollCurriculumRight = () => {
    if (curriculumRef.current) {
      curriculumRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  // industry scroll handlers
  const scrollIndustryLeft = () => {
    if (industryRef.current) {
      industryRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };
  const scrollIndustryRight = () => {
    if (industryRef.current) {
      industryRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };
  const scrollJozunaLeft = () => {
    if (jozunaRef.current) {
      jozunaRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };
  const scrollJozunaRight = () => {
    if (jozunaRef.current) {
      jozunaRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  const [showNotification, setShowNotification] = useState<boolean>(false);

  const formatDateTime = (dateString: string) => {
    // 👇 Force UTC parsing
    const date = new Date(dateString + "Z");

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();

    const time = date.toLocaleString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${day} ${month} ${year} • ${time}`;
  };

  // optional: detect overflow to toggle arrow visibility
  useEffect(() => {
    const checkOverflow = () => {
      if (curriculumRef.current) {
        setShowCurriculumArrows(
          curriculumRef.current.scrollWidth > curriculumRef.current.clientWidth,
        );
      }
      if (industryRef.current) {
        setShowIndustryArrows(
          industryRef.current.scrollWidth > industryRef.current.clientWidth,
        );
      }
      // if (jozunaRef.current) {
      //   setShowJozunaArrows(
      //     jozunaRef.current.scrollWidth > jozunaRef.current.clientWidth
      //   );
      // }
    };

    // check once when apiData comes
    checkOverflow();

    // debounce resize so calculation happens after layout settles
    const handleResize = () => {
      requestAnimationFrame(checkOverflow); // ✅ ensures it runs after reflow
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [apiData]);

  useEffect(() => {
    const checkOverflow = () => {
      requestAnimationFrame(() => {
        if (jozunaRef.current) {
          setShowJozunaArrows(
            jozunaRef.current.scrollWidth > jozunaRef.current.clientWidth,
          );
        }
      });
    };

    checkOverflow();

    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [apiData]);
  useEffect(() => {
    setEvents([
      {
        id: 1,
        courseName: "Elevate: Data and AI Excellence",
        eventName: "Database & SQL Overview Assessment",
        startDate: "01.04.2026 | 10:00 AM",
        endDate: "03.04.2026 | 06:00 PM",
        type: "yellow",
        action: "Start",
      },
      {
        id: 2,
        courseName: "Elevate: Data and AI Excellence",
        eventName: "Expert Driven Live Session",
        startDate: "01.04.2026",
        endDate: "10.00 AM to 12:00 PM",
        type: "purple",
        action: "Join",
      },
      {
        id: 3,
        courseName: "Elevate: Data and AI Excellence",
        eventName: "Expert Driven Live Session",
        startDate: "01.04.2026",
        endDate: "10.00 AM to 12:00 PM",
        type: "purple",
        action: "Join",
      },
      {
        id: 4,
        courseName: "Elevate: Data and AI Excellence",
        eventName: "Database & SQL Overview Assessment",
        startDate: "01.04.2026 | 10:00 AM",
        endDate: "03.04.2026 | 06:00 PM",
        type: "yellow",
        action: "Start",
      },
      {
        id: 5,
        courseName: "Elevate: Data and AI Excellence",
        eventName: "Database & SQL Overview Assessment",
        startDate: "01.04.2026 | 10:00 AM",
        endDate: "03.04.2026 | 06:00 PM",
        type: "yellow",
        action: "Start",
      },
      {
        id: 6,
        courseName: "Elevate: Data and AI Excellence",
        eventName: "Database & SQL Overview Assessment",
        startDate: "01.04.2026 | 10:00 AM",
        endDate: "03.04.2026 | 06:00 PM",
        type: "yellow",
        action: "Start",
      },
    ]);
  }, []);
  const [overlayData, setOverlayData] = useState<{
    title: string;
    chartData?: any;
    toggleOptions?: string[];
    slidebarProgressOptions?: string[];
    slidebarResultsOptions?: string[];
  }>({
    title: "Detailed Insights",
  });

  const handleOpenOverlay = (data: {
    title: string;
    chartData?: any;
    toggleOptions?: string[];
    slidebarProgressOptions?: string[];
    slidebarResultsOptions?: string[];
  }) => {
    setOverlayData(data);
    setIsOverlayOpen(true);
  };

  const api = useApi();
  const getDomainImage = (domainName: string) => {
    switch (domainName?.toLowerCase()) {
      case "learning & innovation":
        return learningnnovation;
      case "life & career":
        return lifecareer;
      case "interdisciplinary":
        return interdisiplinary;
      case "information & media technology":
        return ImT;
      default:
        return ""; // fallback if needed
    }
  };
  const getJozunaCurriculumProgramCardDataAPI = async () => {
    //    if (!apiData) {
    //   return <Loading message="Loading..." />;
    // }
    Loader.showLoading("Loading...");
    setLoading(true);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      Loader.showLoading("Loading...");

      const response = await fetchSyncDashboard(api);
      setApiData(response.data);
      dispatch(setIsGradedQuiz(response.data.is_graded_quiz));
      const hasJozuna = (response.data.jozuna_score?.length ?? 0) > 0;
      dispatch(setHasJozunaSkills(hasJozuna));
    } catch (error) {
      Logger.info("error response", error);
      // Display an error alert or message if needed
    } finally {
      setTimeout(() => {
        Loader.dismissLoading();
        setLoading(false);
      }, 300); // 300ms ensures loader flashes at least
    }
  };
  const [notification, setNotification] = useState<NotificationData | null>(
    null,
  );
  const isGradedQuiz = useSelector(
    (state: RootState) => state.advancedFilterGradedPopQuiz.is_graded_quiz,
  );
  const getNotifications = async () => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<NotificationData>("/notification");

      if (response.data) {
        setNotification(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  //streak up api
  const getStreakUpCountApi = async () => {
    Loader.showLoading("Loading...");
    setLoading(true);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<StreakUpResponse>(
        VideoReportClient.streak_up,
      );
      const data: StreakUpUIResponse = {
        total:
          response.data.total_no_of_assessment +
          response.data.total_no_of_learning_content,
        completed:
          response.data.completed_no_of_assessment +
          response.data.completed_no_of_learning_content,
        completed_percentage_of_learning_content:
          response.data.completed_percentage_of_learning_content,
      };

      setStreakData(data);
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const [galleryCount, setGalleryCount] = useState<number>(0);
  const [hasActivePrograms, setHasActivePrograms] = useState<boolean | null>(
    null,
  );

  const getEprogramsAPI = async () => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    const institute_id = LocalStorage.getLocalData("institute_id");
    try {
      const response = await api.get<any>(`/eprogram/${institute_id}`);
      if (
        response.data?.programs &&
        Array.isArray(response.data.programs) &&
        response.data.programs.length > 0
      ) {
        setHasActivePrograms(true);
        dispatch(setPrograms(response.data.programs));
      } else {
        setHasActivePrograms(false);
        dispatch(setPrograms([]));
      }
    } catch (error) {
      Logger.error("Error fetching eprograms on dashboard:", error);
      setHasActivePrograms(false);
    }
  };

  const getGalleryCountApi = async () => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    try {
      const res = await api.get<any>("/gallery");
      if (res?.data) {
        const count = Number(res.data.count ?? 0);
        setGalleryCount(count);
      }
    } catch (error) {
      Logger.error("Error fetching gallery count for dashboard:", error);
    }
  };

  useEffect(() => {
    getStreakUpCountApi();
    getJozunaCurriculumProgramCardDataAPI();
    getNotifications();
    getPendingItemsVideos(1);
    getPendingItemsActiveAssessments(1);
    // getPendingItemsClosedAssessments(1);
    get_feedback();
    getGalleryCountApi();
    getEprogramsAPI();
  }, []);

  const isProgramsAvailable =
    hasActivePrograms !== null
      ? hasActivePrograms
      : Boolean(listProgramData && listProgramData.length > 0);

  const [loadingActive, setLoadingActive] = useState(true);
  const [assessmentsActive, setAssessmentsActive] = useState<any[]>([]);
  const [assessmentsMissed, setAssessmentsMissed] = useState<any[]>([]);
  const [pendingActiveItems, setPendingActiveItems] = useState<PendingItem[]>(
    [],
  );
  const [isIndependent, setIsIndependentuse] = useState<any>();

  const getPendingItemsActiveAssessments = async (page: number) => {
    // Loader.showLoading("Loading...");
    setLoadingActive(true);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<AssessmentResponse>(
        `/candidate/pending_items?item=Assessments&status=Active&page_number=${page}&limit=${10}`,
      );
      setAssessmentsActive(response.data.records);
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details.isIndependent,
        response.data.is_independent?.toString() ?? "true",
      );
      setIsIndependentuse(response.data.is_independent);
      const activeAssessmentItems: PendingItem[] = response.data.records.map(
        (assessment) => ({
          id: assessment.assessment_entity_id,
          type: "assessment",
          title: assessment.assessment_entity_name,
          action: assessment.status,
          status: "active",
          assessment_entity_id: assessment.assessment_entity_id,
          assessment_id: assessment.assessment_id,
          current_counter: assessment.current_counter,
          time_spend: assessment.time_spend,
          total_question: assessment.total_question,
          assessment_duration: assessment.assessment_duration,
          candidate_assessment_status: assessment.candidate_assessment_status,
          assessment_start_time: assessment.assessment_start_time,
          assessment_expiry: assessment.assessment_expiry,

          // ADD THESE
          assessment_entity_name: assessment.assessment_entity_name,

          dimension_questions: assessment.dimension_questions,

          category_questions: assessment.category_questions,

          curriculum_questions: assessment.curriculum_questions,

          assessment_entity_time_left: assessment.assessment_entity_time_left,

          category_list: assessment.category_list ?? [],

          curriculum_list: assessment.curriculum_list ?? [],
        }),
      );

      setPendingActiveItems((prev) => [...prev, ...activeAssessmentItems]);

      if (
        pendingActiveItems.length + activeAssessmentItems.length >=
        response.data.no_of_records
      ) {
        // setHasMoreActive(false);
      }
    } catch (error) {
      Logger.info("error response", error);
      // setHasMoreActive(false);
    } finally {
      Loader.dismissLoading();
      setLoadingActive(false);
    }
  };

  const [hasMoreMissed, setHasMoreMissed] = useState(true);
  const [pendingMissedItems, setPendingMissedItems] = useState<PendingItem[]>(
    [],
  );

  const getPendingItemsClosedAssessments = async (page: number) => {
    // Loader.showLoading("Loading...");
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<AssessmentResponse>(
        `/candidate/pending_items?item=Assessments&status=Closed&page_number=${page}&limit=${10}`,
      );
      setAssessmentsMissed(response.data.records);
      const missedAssessmentItems: PendingItem[] = response.data.records.map(
        (assessment) => ({
          id: assessment.assessment_entity_id,
          type: "assessment",
          title: assessment.assessment_entity_name,
          action: assessment.status,
          status: "missed",
          assessment_entity_id: assessment.assessment_entity_id,
          assessment_id: assessment.assessment_id,
          current_counter: assessment.current_counter,
          time_spend: assessment.time_spend,
        }),
      );

      setPendingMissedItems((prev) => [...prev, ...missedAssessmentItems]);

      if (
        pendingMissedItems.length + missedAssessmentItems.length >=
        response.data.no_of_records
      ) {
        setHasMoreMissed(false);
      }
    } catch (error) {
      Logger.info("error response", error);
      setHasMoreMissed(false);
    } finally {
      Loader.dismissLoading();
    }
  };

  const hasActiveAssessments = pendingActiveItems.length > 0;

  const clearNotification = async (
    item?: NotificationItem,
    clearAll: boolean = false,
  ) => {
    try {
      api.setAuthToken(LocalStorage.getLocalData("access_token"));

      const res = await api
        .delete("/clear_notification", {
          params: {
            clear_all: clearAll,
          },
          data: item,
        })
        .then((res) => {
          if (clearAll === true) {
            getNotifications();
          }
          return res.data;
        });
    } catch (error) {
      console.error(error);
    }
  };

  const [isModalOpen, setModalOpen] = useState(false);
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const getLinkText = (type: any) => {
    switch (type) {
      case "Assessment":
        return "Take assessment";
      case "Program":
        return "Click to view";
      case "Live Session":
        return "Dive in now";
      default:
        return null;
    }
  };

  const needHelptoggleModal = () => {
    setModalOpen(!isModalOpen);
    if (!isModalOpen) {
      logActionEvent(
        analytics_strings.analytics_events.dashboard_skill_needHelp,
        {
          candidate_id: userData.candidate_id,
        },
      );
    }
  };

  const handleNavigation = (notify: NotificationItem) => {
    if (notify.notification_type === "Program") {
      navigate("/dashboard/learning-room");
    } else if (notify.notification_type === "Assessment") {
      navigate("/dashboard/assessment");
    } else if (notify.notification_type === "Live Session") {
      navigate("/dashboard/livesession");
    } else {
      navigate("/dashboard/learning-room");
    }
  };

  const profileData = useSelector(
    (state: RootState) => state.profile.profileKeys,
  );

  const [pendingItems, setPendingItems] = useState<PendingItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [labData, setLabData] = useState<LabSessionVideoResponse>();

  const [videoData, setVideoData] = useState<TopicVideoResponse>();
  const [recommendationVideoData, setRecommendationVideoData] =
    useState<TopicVideoResponse>();
  const handleResourceClick = (feedback: FeedbackItem) => {
    if (!feedback.video_id) return;

    navigate("/dashboard/learning-room/view-courses/video", {
      state: {
        program_id: feedback.program_id,
        course_id: feedback.course_id,
        topic_id: feedback.topic_id,
        video_id: feedback.video_id,
        program_category: feedback.program_category,
        labSession: feedback.is_lab_session,
        selectedProgramTitle: feedback.program_title,
        isFromDashboard: true,
      },
    });
  };
  const getPendingItemsVideos = async (page: number) => {
    // Loader.showLoading("Loading...");
    setLoading(true);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      // setLoadingMissed(true);

      const response = await api.get<VideoResponse>(
        `/candidate/pending_items?item=Videos&page_number=${page}&limit=${10}&oldest=3`,
      );

      const { no_of_records, records } = response.data;

      // Build video items

      const videoItems: PendingItem[] = records.map((item) => {
        const isVideo =
          item.content_type === "video" ||
          (!item.content_type && !!item.video_title);

        const isPdf =
          item.content_type === "pdf" ||
          (!item.content_type && !item.video_title && !!item.file_title);

        return {
          id: item.video_id || Math.random().toString(),
          topic_id: item.topic_id,
          course_id: item.course_id,
          program_id: item.program_id,
          program_category: item.program_category,
          image: isVideo ? PlayIcon : FileIcon,
          // keep compatible with PendingItem type
          type: isVideo ? "video" : "assessment", // or existing non-video type

          title: isVideo
            ? item.video_title || "Untitled Video"
            : item.file_title || "Untitled File",

          action:
            item.completion_status === "In Progress"
              ? "Resume"
              : isVideo
                ? "Watch"
                : "Read",

          is_lab_session: item.is_lab_session,
        };
      });

      setPendingItems((prev) => [...prev, ...videoItems]);

      // // Pagination stop condition
      // if (page * limit >= no_of_records) {
      //   setHasMoreVideo(false);
      // }
    } catch (error) {
      Logger.info("error response", error);
      // setHasMoreVideo(false);
    } finally {
      Loader.dismissLoading();
      // setLoadingMissed(false);

      setLoading(false);
    }
  };
  const { showAlert } = useAlert();

  const getLabTopicVideos = async (
    courseId?: string,
    video_id?: string,
    topic_id?: string,
    program_id?: string,
  ) => {
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    try {
      const response = await api.get<LabSessionVideoResponse>(
        `${RecommendationIndustryViewClient.labSession}?course_id=${courseId}`,
      );
      setLabData(response.data);
      navigate("/dashboard/learning-room/view-labsession/video", {
        state: {
          video_id: video_id, // For initial video to play
          topic_id: topic_id, // Videos topic id
          video_list: response.data.videos[0].list_videos, // labData for video thumbnail & video id
          course_name: null, // Course name
          course_id: courseId, // Course ID
          // course_topic: selectedItem?.topic_title, // Videos topic title
          program_id: program_id,
          program_category: "Industry",
          labSession: true, // Indicates it's a lab session
          isFromDashboard: true,
        },
      });
      // labSetSelectedItem(response.data)
    } catch (error) {
      Logger.error("Error fetching Lab Topic Videos:", error);
    } finally {
      Loader.dismissLoading();
    }
  };
  const getProgram = async (programId?: string) => {
    Loader.showLoading("Loading...");
    setLoading(true);

    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    const param = {
      program_category: "Industry",
    };

    try {
      const response = await api.get<any>("/list_program", param);

      const options = response.data.programs.map((program: any) => ({
        id: program.program_id,
        title: program.program_title,
        description: program.program_description,
      }));

      // Find the matched program using programId
      const matchedProgram = programId
        ? options.find((program: any) => program.id === programId)
        : null;

      if (matchedProgram) {
        return matchedProgram.title;
      }
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
      setLoading(false);
    }

    return null;
  };
  const getTopicVideos = async (
    topicId?: string,
    course_id?: string,
    program_id?: string,
    video_id?: string,
  ) => {
    const programTitle = await getProgram(program_id);

    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<TopicVideoResponse>(
        RecommendationIndustryViewClient.getCourseVideoUrl,
        {
          course_id: course_id,
          topic_id: topicId,
          program_id: program_id,
          program_category: "Industry",
        },
      );
      setVideoData(response.data);
      const matchedVideo = response.data?.videos?.[0]?.list_videos?.find(
        (video) => video.video_id === video_id,
      );
      navigate("/dashboard/learning-room/view-courses/video", {
        state: {
          video_id: video_id, // For initial video to play
          topic_id: topicId, // Videos topic id
          video_list: response.data?.videos[0].list_videos, // videoData videos
          course_name: null, // Course name
          course_id: course_id, // Course ID
          // course_topic: selectedItem?.topic_title, // Videos topic title
          program_id: program_id,
          program_category: "Industry",
          labSession: false, // Indicates it's not a lab session
          //state Header values
          selectedProgramTitle: programTitle,
          selectedTopicTitle: matchedVideo?.topic_title,
          isFromDashboard: true,
        },
      });

      // setVideoduration(response.data.total_duration);
    } catch (error) {
      Logger.error("Error fetching Course Videos:", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const getRecommendationTopicVideos = async (
    topicId?: string,
    course_id?: string,
    program_id?: string,
    video_id?: string,
  ) => {
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<TopicVideoResponse>(
        RecommendationIndustryViewClient.getCourseVideoUrl,
        {
          course_id: course_id,
          topic_id: topicId,
          program_id: program_id,
          program_category: "Jozuna",
        },
      );
      setRecommendationVideoData(response.data);
      navigate("/dashboard/recommendation/jozunaview/video", {
        state: {
          video_id: video_id, // For initial video to play
          topic_id: topicId, // Videos topic id
          video_list: response.data?.videos[0].list_videos, // videoData videos
          course_name: null, // Course name
          course_id: course_id, // Course ID
          // course_topic: selectedItem?.topic_title, // Videos topic title
          program_id: program_id,
          program_category: "Jozuna",
          labSession: false, // Indicates it's not a lab session
        },
      });
      // setVideoduration(response.data.total_duration);
    } catch (error) {
      Logger.error("Error fetching Course Videos:", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const checkSubscriptionValidation = async (): Promise<boolean> => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    Loader.showLoading("Loading...");
    try {
      const response = await api.get<SubscriptionResponse>(
        AssessmentQuestionModuleClient.check_subscription,
      );

      const data = response.data;

      if (data.error) {
        showAlert({
          show: true,
          title: "Error",
          message: data.error,
          alertType: "error",
          onlyNeedOneButton: true,
          button1Text: "Cancel",
          btn1onPressed() { },
        });
        return true;
      }

      return false;
    } catch (error) {
      Logger.error("Error fetching assessment status:", error);
      return false;
    } finally {
      Loader.dismissLoading();
    }
  };

  const [previousFeedback, setPreviousFeedback] = useState<FeedbackItem[]>([]);

  // const get_feedback = async () => {
  //   api.setAuthToken(LocalStorage.getLocalData("access_token"));

  //   try {
  //     const res = await api.get<FeedbackResponse>("/feedback", {
  //       candidate_id: userData.candidate_id,
  //     });
  //     setPreviousFeedback(res.data.feedback || []);
  //     console.log("Feedback data:", res.data.feedback);
  //   } catch (error) {
  //     console.error("Failed to fetch feedback", error);
  //   }
  // };

  const handleAssessmentClick = async (item: any) => {
    const isIndependentCheck = LocalStorage.getLocalData("isIndependent");
    if (item.action !== "Resume" && isIndependentCheck === "false") {
      //Check Trail Assessment Exceed for Start Assessment
      const subscriptionFailed = await checkSubscriptionValidation();
      if (subscriptionFailed === true) {
        return;
      }
    }
    if (
      item.candidate_assessment_status === strings.assessment_status.initated ||
      item.candidate_assessment_status === strings.assessment_status.inProgress
    ) {
      // Redux dispatch
      dispatch(setAssessmentId(item.assessment_id || ""));
      dispatch(setCurrentCounter(item?.current_counter!));
      dispatch(setDuration(item?.assessment_duration!));
      dispatch(setStatus(item.candidate_assessment_status));
      dispatch(setTimeSpend(item?.time_spend!));
      dispatch(setTotalQuestion(item?.total_question!));
      dispatch(setIsIndependent(isIndependent));

      // LocalStorage
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details.duration,
        item?.assessment_duration?.toString() ?? "0",
      );
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details.time_spend,
        item?.time_spend?.toString() ?? "0",
      );
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details
          .candidate_assessment_status,
        item.candidate_assessment_status,
      );
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details.assessment_id,
        item.assessment_id || "",
      );
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details.current_counter,
        item?.current_counter?.toString() ?? "0",
      );
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details.total_question,
        item?.total_question?.toString() ?? "0",
      );
    } else if (
      item.candidate_assessment_status === strings.assessment_status.notStarted
    ) {
      // Redux dispatch
      dispatch(setDuration(item?.assessment_duration!));
      dispatch(setTotalQuestion(item?.total_question!));
      dispatch(setStatus(item.candidate_assessment_status));
      dispatch(setIsIndependent(isIndependent));

      // LocalStorage
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details.duration,
        item?.assessment_duration?.toString() ?? "0",
      );
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details
          .candidate_assessment_status,
        item.candidate_assessment_status,
      );

      Logger.info("Assessment not started");
    }
    LocalStorage.setLocalData(
      strings.localStorage_keys.assessment_details.assessment_expiry_time,
      item.assessment_expiry.toString(),
    );

    LocalStorage.setLocalData(
      strings.localStorage_keys.assessment_details.assessment_start_time,
      item.assessment_start_time.toString(),
    );
    const warningText = CommonUtils.getAssessmentTimeWarning(item, true);
    if (warningText) {
      showAlert({
        show: true,
        title: "Warning",
        message: warningText,
        alertType: "error",
        onlyNeedOneButton: true,
        button1Text: "Ok",
        btn1onPressed() {
          // Navigate after preparing everything
          navigate("/dashboard/assessment/cameracheck", {
            state: {
              assessmentList: item,
              selectedAssessment: item, // pass selected card
            },
          });
        },
      });
      return;
    } else {
      // Navigate after preparing everything
      navigate("/dashboard/assessment/cameracheck", {
        state: {
          assessmentList: item,
          selectedAssessment: item, // pass selected card
        },
      });
    }
  };

  const [randomText, setRandomText] = useState(motivationalTexts[0]);

  useEffect(() => {
    const interval = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * motivationalTexts.length);

      setRandomText(motivationalTexts[randomIndex]);
    }, 4000); // changes every 4 seconds

    return () => clearInterval(interval);
  }, []);

  const uniquePendingItems = pendingItems.filter(
    (item, index, self) => index === self.findIndex((i) => i.id === item.id),
  );

  const uniquePendingActiveItems = pendingActiveItems.filter(
    (item, index, self) => index === self.findIndex((i) => i.id === item.id),
  );

  const uniquePendingMissedItems = pendingMissedItems.filter(
    (item, index, self) => index === self.findIndex((i) => i.id === item.id),
  );

  // const hasActiveAssessments = uniquePendingActiveItems.length > 0;
  const hasClosedAssessments = uniquePendingMissedItems.length > 0;

  // Show Interactive Activities section if either exists
  const hasInteractiveActivities = hasActiveAssessments || hasClosedAssessments;

  const hasLearningContent = uniquePendingItems.length > 0;
  // const hasInteractiveActivities = uniquePendingActiveItems.length > 0;
  const showLearning =
    profileData.partner_institute === true &&
    (hasLearningContent || !hasInteractiveActivities);

  const showInteractive = hasInteractiveActivities || !hasLearningContent;
  const isSingleColumn =
    (showLearning && !showInteractive) || (!showLearning && showInteractive);
  const showBothColumnsForEmptyState =
    !hasLearningContent && !hasActiveAssessments && hasClosedAssessments;
  const [isHovered, setIsHovered] = useState(false);
  const [totalFeedbackCount, setTotalFeedbackCount] = useState(0);

  // Helper function to render feedback message with chips and preserve line breaks
  // const renderFeedbackMessage = (
  //   message: string,
  //   feedbackData?: FeedbackItem,
  // ): React.ReactNode => {
  //   if (!message) return null;

  //   // Split by newlines to preserve line breaks
  //   const lines = message.split("\n");

  //   return lines.map((line, lineIndex) => {
  //     const trimmedLine = line;

  //     // Find all matches in this line
  //     const patterns: { regex: RegExp; className: string; type: string }[] = [];

  //     // Resource pattern
  //     if (feedbackData?.video_name) {
  //       const escapedName = feedbackData.video_name.replace(
  //         /[-\/\\^$*+?.()|[\]{}]/g,
  //         "\\$&",
  //       );
  //       patterns.push({
  //         regex: new RegExp(`\\/\\s*${escapedName}`, "g"),
  //         className: "common-feedback-resource",
  //         type: "resource",
  //       });
  //     } else {
  //       patterns.push({
  //         regex: /\/\s+([^#+*!\n]+?)(?=\s+[+#*!]|\s+[a-z]|\s*$)/g,
  //         className: "common-feedback-resource",
  //         type: "resource",
  //       });
  //     }

  //     // Module pattern
  //     if (feedbackData?.module_name) {
  //       const escapedName = feedbackData.module_name.replace(
  //         /[-\/\\^$*+?.()|[\]{}]/g,
  //         "\\$&",
  //       );
  //       const score = feedbackData.module_score || "\\d+";
  //       patterns.push({
  //         regex: new RegExp(`\\+\\s*${escapedName}\\s*${score}%?`, "g"),
  //         className: "common-feedback-module",
  //         type: "module",
  //       });
  //     } else {
  //       patterns.push({
  //         regex: /\+(.*?)\s+(\d+)%/g,
  //         className: "common-feedback-module",
  //         type: "module",
  //       });
  //     }

  //     // Event pattern
  //     if (feedbackData?.event_name) {
  //       const escapedName = feedbackData.event_name.replace(
  //         /[-\/\\^$*+?.()|[\]{}]/g,
  //         "\\$&",
  //       );
  //       patterns.push({
  //         regex: new RegExp(`#\\s*${escapedName}`, "g"),
  //         className: "common-feedback-event",
  //         type: "event",
  //       });
  //     } else {
  //       patterns.push({
  //         regex: /#([^#+*!/\s][^#+*!]*?)(?=\s+[+#*!]|\s*$)/g,
  //         className: "common-feedback-event",
  //         type: "event",
  //       });
  //     }

  //     // Report pattern
  //     patterns.push({
  //       regex:
  //         /\*\s*(Overall Progress|Completion Steps)(?:\s+(\d+(?:\/\d+)?%?))?/gi,
  //       className: "common-feedback-report",
  //       type: "report",
  //     });

  //     // Attention/Kudos pattern
  //     patterns.push({
  //       regex: /!\s+((?:[⚠☆★]\s+)?(?:Attention|attention|Kudos|kudos))/g,
  //       className: "common-feedback-attention",
  //       type: "attention",
  //     });

  //     const matches: {
  //       start: number;
  //       end: number;
  //       text: string;
  //       className: string;
  //       type: string;
  //     }[] = [];

  //     patterns.forEach(({ regex, className, type }) => {
  //       let match: RegExpExecArray | null;
  //       const regexCopy = new RegExp(regex.source, "g");
  //       while ((match = regexCopy.exec(trimmedLine)) !== null) {
  //         const fullMatch = match[0];
  //         const start = match.index;
  //         const end = start + fullMatch.length;

  //         // For attention, check if it's kudos
  //         let finalClassName = className;
  //         let finalType = type;
  //         if (type === "attention") {
  //           const label = match[1];
  //           if (
  //             label &&
  //             (label.includes("☆") ||
  //               label.includes("Kudos") ||
  //               label.includes("kudos") ||
  //               label.includes("★"))
  //           ) {
  //             finalClassName = "common-feedback-kudos";
  //             finalType = "kudos";
  //           }
  //         }

  //         matches.push({
  //           start,
  //           end,
  //           text: fullMatch,
  //           className: finalClassName,
  //           type: finalType,
  //         });
  //       }
  //     });

  //     // Sort matches by start position
  //     matches.sort((a, b) => a.start - b.start);

  //     // Build the JSX for this line
  //     const parts: React.ReactNode[] = [];
  //     let lastIndex = 0;

  //     matches.forEach((match, index) => {
  //       // Add text before the match
  //       if (match.start > lastIndex) {
  //         parts.push(
  //           <span key={`text-${lineIndex}-${index}-before`}>
  //             {trimmedLine.substring(lastIndex, match.start)}
  //           </span>,
  //         );
  //       }

  //       // Custom chip formatting based on type to match image
  //       // if (match.type === "module") {
  //       //   const cleaned = match.text.replace(/^\+\s*/, "").trim();
  //       //   const pctMatch = cleaned.match(/(.*?)\s+(\d+)\s*%?$/);
  //       //   if (pctMatch) {
  //       //     const moduleName = pctMatch[1].trim();
  //       //     const percentage = pctMatch[2] + "%";
  //       //     parts.push(
  //       //       <span
  //       //         key={`chip-${lineIndex}-${index}`}
  //       //         className="feedback-split-badge-container"
  //       //       >
  //       //         <span className="feedback-split-badge-left module-left">
  //       //           {moduleName}
  //       //         </span>
  //       //         <span className="feedback-split-badge-right module-right">
  //       //           {percentage}
  //       //         </span>
  //       //       </span>,
  //       //     );
  //       //   } else {
  //       //     parts.push(
  //       //       <span
  //       //         key={`chip-${lineIndex}-${index}`}
  //       //         className="feedback-split-badge-container"
  //       //       >
  //       //         <span className="feedback-split-badge-left module-left">
  //       //           {cleaned}
  //       //         </span>
  //       //       </span>,
  //       //     );
  //       //   }
  //       // }
  //       // In your renderFeedbackMessage function, update the module section:

  //       // In renderFeedbackMessage, replace the module match section with this:

  //       if (match.type === "module") {
  //         const cleaned = match.text.replace(/^\+\s*/, "").trim();
  //         const pctMatch = cleaned.match(/(.*?)\s+(\d+)\s*%?$/);
  //         if (pctMatch) {
  //           const moduleName = pctMatch[1].trim();
  //           const percentage = pctMatch[2] + "%";
  //           parts.push(
  //             <span
  //               key={`chip-${lineIndex}-${index}`}
  //               className="module-pill-single"
  //               style={{
  //                 backgroundColor: "#fef3e8",
  //                 color: "#9a5a1a",
  //                 border: "1px solid #fcdba8",
  //                 // padding: "0 14px",
  //                 borderRadius: "8px",
  //                 fontSize: "12px",
  //                 fontWeight: "500",
  //                 height: "26px",
  //                 lineHeight: "26px",
  //                 display: "inline-flex",
  //                 alignItems: "center",
  //                 gap: "6px",
  //                 fontFamily: '"Mazzard"',
  //               }}
  //             >
  //               <span>{moduleName}</span>
  //               <span
  //                 style={{
  //                   fontWeight: "600",
  //                   color: "#ffffff",
  //                   backgroundColor: "#1DA97A",
  //                   fontSize: "10px",
  //                   display: "flex",
  //                   alignContent: "center",
  //                   justifyContent: "center",
  //                   alignItems: "center",
  //                   height: "20px",
  //                   borderRadius: "3px",
  //                   paddingRight: "3px",
  //                   paddingLeft: "3px",
  //                 }}
  //               >
  //                 {percentage}
  //               </span>
  //             </span>,
  //           );
  //         } else {
  //           parts.push(
  //             <span
  //               key={`chip-${lineIndex}-${index}`}
  //               className="module-pill-single"
  //             >
  //               {cleaned}
  //             </span>,
  //           );
  //         }
  //       }
  //       if (match.type === "report") {
  //         const cleaned = match.text.replace(/^\*\s*/, "").trim();
  //         const valMatch = cleaned.match(
  //           /(Overall Progress|Completion Steps)\s+(\d+(?:\/\d+)?%?)$/i,
  //         );
  //         if (valMatch) {
  //           const reportName = valMatch[1].trim();
  //           const value = valMatch[2].trim();
  //           parts.push(
  //             <span
  //               key={`chip-${lineIndex}-${index}`}
  //               style={{
  //                 backgroundColor: "#e6f7f0",
  //                 color: "#0f7a5a",
  //                 border: "1px solid #a8e0cc",
  //                 padding: "0 14px",
  //                 borderRadius: "20px",
  //                 fontSize: "12px",
  //                 fontWeight: "500",
  //                 height: "26px",
  //                 lineHeight: "26px",
  //                 display: "inline-flex",
  //                 alignItems: "center",
  //                 gap: "6px",
  //                 fontFamily: '"Mazzard", sans-serif',
  //               }}
  //             >
  //               <span>{reportName}</span>
  //               <span
  //                 style={{
  //                   fontWeight: "700",
  //                   color: "#0f7a5a",
  //                   fontSize: "12px",
  //                 }}
  //               >
  //                 {value}
  //               </span>
  //             </span>,
  //           );
  //         } else {
  //           parts.push(
  //             <span
  //               key={`chip-${lineIndex}-${index}`}
  //               className="common-feedback-inline-chip common-feedback-report"
  //             >
  //               {cleaned}
  //             </span>,
  //           );
  //         }
  //       }
  //       //  else if (match.type === "report") {
  //       //   const cleaned = match.text.replace(/^\*\s*/, "").trim();
  //       //   const valMatch = cleaned.match(
  //       //     /(Overall Progress|Completion Steps)\s+(\d+(?:\/\d+)?%?)$/i,
  //       //   );
  //       //   if (valMatch) {
  //       //     const reportName = valMatch[1].trim();
  //       //     const value = valMatch[2].trim();
  //       //     parts.push(
  //       //       <span
  //       //         key={`chip-${lineIndex}-${index}`}
  //       //         className="feedback-split-badge-container"
  //       //       >
  //       //         <span className="feedback-split-badge-left report-left">
  //       //           {reportName}
  //       //         </span>
  //       //         <span className="feedback-split-badge-right report-right">
  //       //           {value}
  //       //         </span>
  //       //       </span>,
  //       //     );
  //       //   } else {
  //       //     parts.push(
  //       //       <span
  //       //         key={`chip-${lineIndex}-${index}`}
  //       //         className="feedback-split-badge-container"
  //       //       >
  //       //         <span className="feedback-split-badge-left report-left">
  //       //           {cleaned}
  //       //         </span>
  //       //       </span>,
  //       //     );
  //       //   }
  //       // }
  //       else if (match.type === "attention") {
  //         const cleaned = match.text
  //           .replace(/^!\s*/, "")
  //           .replace(/^[⚠☆★]\s*/, "")
  //           .trim();
  //         parts.push(
  //           <span
  //             key={`chip-${lineIndex}-${index}`}
  //             className="feedback-pill attention-pill"
  //           >
  //             <span className="feedback-pill-icon">⚠</span>
  //             <span className="feedback-pill-text">{cleaned}</span>
  //           </span>,
  //         );
  //       } else if (match.type === "kudos") {
  //         const cleaned = match.text
  //           .replace(/^!\s*/, "")
  //           .replace(/^[⚠☆★]\s*/, "")
  //           .trim();
  //         parts.push(
  //           <span
  //             key={`chip-${lineIndex}-${index}`}
  //             className="feedback-pill kudos-pill"
  //           >
  //             <span className="feedback-pill-icon">☆</span>
  //             <span className="feedback-pill-text">{cleaned}</span>
  //           </span>,
  //         );
  //       } else if (match.type === "resource") {
  //         let cleaned = match.text.replace(/^\/\s*/, "").trim();
  //         if (!cleaned.toLowerCase().startsWith("video:")) {
  //           cleaned = "Video: " + cleaned;
  //         }
  //         parts.push(
  //           <span
  //             key={`chip-${lineIndex}-${index}`}
  //             className="feedback-pill resource-pill"
  //           >
  //             <span className="feedback-pill-text">{cleaned}</span>
  //           </span>,
  //         );
  //       } else if (match.type === "event") {
  //         const cleaned = match.text.replace(/^#\s*/, "").trim();
  //         parts.push(
  //           <span
  //             key={`chip-${lineIndex}-${index}`}
  //             className="feedback-pill event-pill"
  //           >
  //             <span className="feedback-pill-text">{cleaned}</span>
  //           </span>,
  //         );
  //       } else {
  //         parts.push(
  //           <span
  //             key={`chip-${lineIndex}-${index}`}
  //             className={`common-feedback-inline-chip ${match.className}`}
  //           >
  //             {match.text}
  //           </span>,
  //         );
  //       }

  //       lastIndex = match.end;
  //     });

  //     // Add remaining text
  //     if (lastIndex < trimmedLine.length) {
  //       parts.push(
  //         <span key={`text-${lineIndex}-end`}>
  //           {trimmedLine.substring(lastIndex)}
  //         </span>,
  //       );
  //     }

  //     // If no matches found, just return the line as text
  //     if (matches.length === 0) {
  //       return (
  //         <div
  //           key={`line-${lineIndex}`}
  //           className="common-feedback-message-line"
  //         >
  //           {trimmedLine || "\u00A0"}
  //         </div>
  //       );
  //     }

  //     return (
  //       <div key={`line-${lineIndex}`} className="common-feedback-message-line">
  //         {parts}
  //       </div>
  //     );
  //   });
  // };

  // Get initials from name
  const getInitials = (name: string): string => {
    if (!name) return "??";
    const parts = name.split(" ");
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  // Helper for date ordinal suffix
  const getOrdinalSuffix = (day: number) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const checkScroll = () => {
    if (!scrollRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;

    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
  };
  const scrollLeft = () => {
    scrollRef.current?.scrollBy({
      left: -300,
      behavior: "smooth",
    });

    setTimeout(checkScroll, 350);
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({
      left: 300,
      behavior: "smooth",
    });

    setTimeout(checkScroll, 350);
  };
  useEffect(() => {
    requestAnimationFrame(() => {
      checkScroll();
    });
  }, [activeTab]);
  // Format date
  const formatDate = (dateString: string): string => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString.replace(/,/, ""));
      if (isNaN(date.getTime())) return dateString;
      const day = date.getDate();
      const month = date.toLocaleString("en-US", { month: "long" });
      const year = date.getFullYear();
      return `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;
    } catch {
      return dateString;
    }
  };

  const get_feedback = async () => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    setLoading(true);

    try {
      const res = await api.get<FeedbackResponse>("/feedback", {
        page_number: 1,
        limit: 3,
      });
      const feedbacks = res.data.feedback || [];
      setTotalFeedbackCount(res.data.number_of_records);
      // Get only the last 3 feedbacks
      setPreviousFeedback(feedbacks);
      console.log("Last 3 Feedback data:", feedbacks);
    } catch (error) {
      console.error("Failed to fetch feedback", error);
    } finally {
      setLoading(false);
    }
  };

  if (!apiData) {
    return <></>;
  }

  return (
    <div style={{ overflow: "auto" }}>
      <div className="v2-dashboard-container">
        <div
          className="v2-dashboard-header"
          style={
            {
              // paddingBottom: "35px",
            }
          }
        >
          <div
            style={{
              display: "flex",
              alignItems: "start",
              justifyContent: "space-between",
              boxShadow: "0 4px 8px rgba(105, 103, 103, 0.1)", // Bottom box shadow
              padding: "20px",
              zIndex: 10000,
              height: "12vh",
            }}
          >
            <div
              style={{
                color: "#000000",
                // marginLeft: "20px",
                fontWeight: "600",
                fontFamily: "Mazzard",
                fontSize: "18px",
                // marginRight: "20px", // Adjust margin to provide space after the welcome message
              }}
            >
              {profileData.first_name} {profileData.last_name}'s Growth
              Dashboard
              <div
                style={{
                  color: "#000000",
                  //   marginLeft: "20px",
                  fontWeight: "300",
                  fontFamily: "Mazzard",
                  fontSize: "14px",
                  //   marginRight: "20px", // Adjust margin to provide space after the welcome message
                }}
              >
                Let's make today count. Here is your learning progress.
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  backgroundColor: "#FFDCD1",
                  borderRadius: "30px",
                  padding: "10px",
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <img
                  src={motivationIcon}
                  alt=""
                  style={{ height: "20px", width: "20px" }}
                />
                <span
                  style={{
                    fontFamily: "AutourOne",
                    fontSize: "14px",
                  }}
                >
                  {randomText}
                </span>
                <img
                  src={cancelIcon}
                  alt=""
                  style={{ height: "20px", width: "20px" }}
                />
              </div>
              <div
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={() => {
                  navigate("/dashboard/certificates");
                }}
                style={{
                  background:
                    "linear-gradient(180deg, #0061A4 0%, #188C90 100%)",
                  borderRadius: "30px",
                  padding: "8px 8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                  width: "fit-content",
                }}
              >
                <img
                  src={viewCertificateIcon}
                  alt=""
                  style={{
                    height: "30px",
                    width: "30px",
                  }}
                />

                {isHovered && (
                  <span style={{ color: "#fff", fontWeight: 500 }}>
                    View Certificates
                  </span>
                )}
              </div>
              <img
                src={
                  notification?.notification_data?.length
                    ? notificationIcon
                    : noNotificationIcon
                }
                alt=""
                onClick={() => {
                  setShowNotification(true);
                }}
                style={{
                  height: "40px",
                  width: "40px",
                  cursor: "pointer",
                  position: "relative", //  IMPORTANT
                }}
              />
              {showNotification && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.4)",
                    zIndex: 9998,
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-start",
                    paddingTop: "25px",
                    paddingRight: "40px",
                  }}
                >
                  <div
                    style={{
                      width: "500px",
                      backgroundColor: "#ffffff",
                      borderRadius: "20px",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                      zIndex: 9999,
                      display: "flex",
                      flexDirection: "column",
                      maxHeight: "500px",
                    }}
                  >
                    <div style={{ padding: "20px 20px 0 20px" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "4px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                          }}
                        >
                          <img
                            src={
                              notification?.notification_data?.length
                                ? notificationIcon
                                : noNotificationIcon
                            }
                            alt=""
                            style={{ width: "40px", height: "40px" }}
                          />
                          <div
                            style={{
                              fontWeight: 600,
                              fontSize: "18px",
                            }}
                          >
                            Notifications
                            <div
                              style={{
                                fontSize: "13px",
                                color: "#6c757d",
                              }}
                            >
                              Stay updated with your latest notifications
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex", gap: "10px" }}>
                          {" "}
                          {notification!.notification_data.length > 0 && (
                            <div
                              onClick={() => {
                                clearNotification(undefined, true);
                                setShowNotification(false);
                              }}
                              style={{
                                // background: "#e7efff",
                                // padding: "3px",
                                // color: "black",
                                // borderRadius: "4px",
                                fontFamily: "Mazzard",
                                paddingTop: "5px",
                                cursor: "pointer",
                                fontSize: "15px",
                              }}
                            >
                              Clear all
                            </div>
                          )}
                          <img
                            onClick={() => setShowNotification(false)}
                            alt=""
                            src={notifyCancel}
                            style={{
                              cursor: "pointer",

                              width: "28px",
                              height: "28px",
                            }}
                          />
                        </div>
                      </div>
                      <hr
                        style={{
                          border: "0.5px solid #eee",
                          margin: "12px 0 0 0",
                        }}
                      />
                    </div>

                    <div
                      style={{
                        flex: 1,
                        overflowY: "auto",
                        padding: "0 20px 20px 20px",
                        marginTop: "8px",
                      }}
                    >
                      {notification?.notification_data?.length === 0 && (
                        <div
                          style={{
                            textAlign: "center",
                            color: "#adb5bd",
                            fontSize: "13px",
                            marginTop: "20px",
                          }}
                        >
                          No notifications found
                        </div>
                      )}

                      {[...(notification?.notification_data || [])]
                        .sort(
                          (a, b) =>
                            new Date(b.date_time).getTime() -
                            new Date(a.date_time).getTime(),
                        )
                        .map((notif, index) => (
                          <div
                            key={index}
                            style={{
                              marginBottom: "20px",
                              display: "flex",
                              gap: "12px",
                            }}
                          >
                            {/* Left indicator */}
                            <div
                              style={{
                                width: "3px",
                                backgroundColor: "#3366FF3D",
                                borderRadius: "2px",
                                flexShrink: 0,
                              }}
                            />

                            <div style={{ flex: 1 }}>
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#212529",
                                  fontWeight: 500,
                                }}
                              >
                                {notif.title}
                              </div>

                              {/* <div
                              style={{
                                fontSize: "12px",
                                color: "#6c757d",
                                marginTop: "4px",
                              }}
                            >
                              {notif.body}
                            </div> */}
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#6c757d",
                                  marginTop: "4px",
                                }}
                              >
                                {notif.body}{" "}
                                {getLinkText(notif.notification_type) && (
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      color: "black",
                                      cursor: "pointer",
                                      marginLeft: "4px",
                                    }}
                                    onClick={() => {
                                      clearNotification(notif);
                                      handleNavigation(notif);
                                    }}
                                  >
                                    {getLinkText(notif.notification_type)}
                                  </span>
                                )}
                              </div>

                              <div
                                style={{
                                  fontSize: "11px",
                                  color: "#adb5bd",
                                  marginTop: "4px",
                                }}
                              >
                                {formatDateTime(notif.date_time)}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}
              <img
                onClick={needHelptoggleModal}
                src={faqIcon}
                alt=""
                style={{ height: "40px", width: "40px", cursor: "pointer" }}
              />
            </div>
          </div>
        </div>

        <div
          className="v2-dash-main-content"
        // style={{
        //   padding: "20px",
        //   paddingBottom: "0px",
        //   marginBottom: "0px",
        //   backgroundColor: "blue",
        //   height: "88vh",
        // }}
        >
          <div className="v2-dash-top">
            {/* ROW 1: Overall Progress & Feedback (left 60%) + Progress Gallery (right 40%) */}
            <div className="v2-dash-row">
              <div className="v2-dash-row-left">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    gap: "20px",
                    height: "100%",
                  }}
                >
                  <div
                    className="v2-dash-overall"
                    style={{ width: totalFeedbackCount === 0 ? "100%" : "65%" }}
                  >
                    <div className="v2-dash-overallTop">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <div className="v2-dash-overallTxt">
                          Overall Progress
                        </div>
                        <Tooltip
                          title="The overall completion percentage of all assigned videos and assessments."
                          arrow
                          placement="top"
                        >
                          <img
                            src={infoImg}
                            style={{
                              cursor: "pointer",
                              alignContent: "center",
                              alignItems: "center",
                              paddingTop: "10px",
                              width: "16px",
                            }}
                          />
                        </Tooltip>
                      </div>
                      <div className="v2-dash-rightSection">
                        <div
                          className={`v2-dash-percentageTxt ${apiData.overall_progress <= 40
                            ? "progress-red"
                            : apiData.overall_progress <= 80
                              ? "progress-yellow"
                              : "progress-green"
                            }`}
                        >
                          {apiData.overall_progress ?? 0}%
                        </div>

                        {/* <div
                        className={
                          apiData.overall_progress === 0
                            ? "v2-dash-GoToLearning-edgeCase"
                            : "v2-dash-GoToLearning"
                        }
                        onClick={() => {
                          navigate("/dashboard/learning-room");
                        }}
                      >
                        Go to Learning Room
                        <img
                          src={rightArrow}
                          alt=""
                          style={{
                            height: "20px",
                            width: "18px",
                          }}
                        />
                      </div> */}
                      </div>
                    </div>

                    {apiData.overall_progress === 0 && (
                      <div className="v2-dash-overallDescription">
                        * This represents the percentage of all your required
                        learning items (like videos, assignments, and pop
                        quizzes) that you have completed so far across all your
                        courses. It's a snapshot of how far you've come in your
                        curriculum.
                      </div>
                    )}
                  </div>
                  {totalFeedbackCount !== 0 && (
                    <div
                      className="v2-dashboard-feedback-card"
                      style={{ height: "100%" }}
                    >
                      <div className="v2-dashboard-feedback-header">
                        <h3 className="v2-dashboard-feedback-title">
                          Feedback{" "}
                          <span className="v2-dashboard-feedback-count">
                            ( {totalFeedbackCount} )
                          </span>
                        </h3>

                        <div
                          className="v2-dashboard-feedback-viewall"
                          onClick={() => {
                            navigate("feedback");
                          }}
                        >
                          View all
                          <img
                            src={viewAllFeedback}
                            alt=""
                            className="v2-dashboard-feedback-arrow"
                          />
                        </div>
                      </div>

                      <div className="v2-dashboard-feedback-footer">
                        <img
                          src={feedbackMessageIcon}
                          alt=""
                          className="v2-dashboard-feedback-icon"
                        />

                        <div
                          className="v2-dashboard-feedback-last"
                          onClick={() => {
                            setFeedbackOpenOverLay(true);
                          }}
                        >
                          View last 3 feedbacks
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="v2-dash-row-right">
                <div className="v2-dashboard-gallery-card">
                  <div className="v2-dashboard-feedback-header">
                    <h3 className="v2-dashboard-feedback-title">
                      Progress Gallery{" "}
                      <span className="v2-dashboard-feedback-count">
                        ( {galleryCount} )
                      </span>
                    </h3>

                    <button
                      className="v2-dashboard-gallery-nav-btn"
                      disabled={!isProgramsAvailable}
                      onClick={() => {
                        if (isProgramsAvailable) {
                          navigate("/dashboard/gallery");
                        }
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "7px 16px",
                        borderRadius: "20px",
                        background: isProgramsAvailable
                          ? "linear-gradient(135deg, #173f8a 0%, #2563eb 100%)"
                          : "#94a3b8",
                        color: "#ffffff",
                        border: "none",
                        fontSize: "13px",
                        fontFamily: "Mazzard, sans-serif",
                        fontWeight: 600,
                        cursor: isProgramsAvailable ? "pointer" : "not-allowed",
                        opacity: isProgramsAvailable ? 1 : 0.6,
                        boxShadow: isProgramsAvailable
                          ? "0 2px 8px rgba(37, 99, 235, 0.25)"
                          : "none",
                        transition: "all 0.2s ease-in-out",
                      }}
                    >
                      <span>View all progress uploads</span>
                    </button>
                  </div>

                  <div
                    className="v2-dashboard-feedback-footer"
                    onClick={() => {
                      if (isProgramsAvailable) {
                        navigate("/dashboard/gallery");
                      }
                    }}
                    style={{
                      cursor: isProgramsAvailable ? "pointer" : "not-allowed",
                      opacity: isProgramsAvailable ? 1 : 0.6,
                    }}
                  ></div>
                </div>
              </div>
            </div>

            {/* ROW 2: Completion Steps (left 60%) + Mini Calendar (right 40%) */}
            <div className="v2-dash-row">
              <div className="v2-dash-row-left">
                <div className="v2-dash-engagement">
                  {/* TOP HEADER */}
                  <div className="v2-dash-engagementTop">
                    <div className="v2-dash-engagementTop-left">
                      <div className="v2-dash-engagementTitle">
                        Completion steps
                      </div>

                      {streakData?.completed !== 0 && (
                        <>
                          <img
                            src={streakImg}
                            alt=""
                            style={{ height: "20px", width: "20px" }}
                          />

                          <div
                            className="v2-dash-streakUp"
                            onClick={() => {
                              setOpenOverlay(true);
                            }}
                          >
                            How to Step Up?
                          </div>
                        </>
                      )}
                    </div>

                    <div className="v2-dash-engagementTop-right">
                      <img
                        src={fire}
                        alt=""
                        style={{
                          height: "22px",
                          width: "22px",
                        }}
                      />
                      {streakData?.completed}/{streakData?.total}
                    </div>
                  </div>

                  {/* EMPTY STATE UI */}
                  {streakData?.total === 0 ? (
                    <div className="v2-dash-zero-streak-wrapper">
                      <div className="v2-dash-zero-streak-subtext">
                        * Complete at least one learning activity daily to keep
                        your streak up.
                      </div>

                      <div className="v2-dash-zero-streak-cards">
                        <div className="v2-dash-zero-streak-card">
                          <div className="v2-dash-zero-streak-card-title">
                            Assessment
                          </div>

                          <div className="v2-dash-zero-streak-card-desc">
                            Submit an assignment to count towards your streak.
                          </div>
                        </div>

                        {profileData.partner_institute === true && (
                          <div className="v2-dash-zero-streak-card">
                            <div className="v2-dash-zero-streak-card-title">
                              Learning Content
                            </div>

                            <div className="v2-dash-zero-streak-card-desc">
                              Watch a video or read a document to earn a streak
                              point.
                            </div>
                          </div>
                        )}

                        {profileData.partner_institute === true && (
                          <div className="v2-dash-zero-streak-card">
                            <div className="v2-dash-zero-streak-card-title">
                              Live Session
                            </div>

                            <div className="v2-dash-zero-streak-card-desc">
                              Attend a scheduled live session to maintain your
                              streak.
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="v2-dash-engagement-list">
                      <div
                        className="v2-dash-overallpending-container"
                        style={{
                          display: "grid",
                          gridTemplateColumns: showBothColumnsForEmptyState
                            ? "1fr 1fr"
                            : isSingleColumn
                              ? "1fr"
                              : "1fr 1fr",
                          gap: "20px",
                        }}
                      >
                        {/* LEARNING CONTENTS */}
                        {(showLearning ||
                          (!hasLearningContent &&
                            !hasActiveAssessments &&
                            hasClosedAssessments)) && (
                            <div
                              className="v2-dash-overallpending-column"
                              style={{
                                width: "100%",
                                gridColumn: showBothColumnsForEmptyState
                                  ? "auto"
                                  : isSingleColumn
                                    ? "1 / -1"
                                    : "auto",
                              }}
                            >
                              <div className="v2-dash-overallpending-card">
                                <div className="v2-dash-overallpending-header">
                                  <span>Learning Contents</span>

                                  {!loading && hasLearningContent && (
                                    <span
                                      className="v2-dash-overallpending-view"
                                      onClick={() => {
                                        navigate("/dashboard/learning-room");
                                      }}
                                    >
                                      Learning room{" "}
                                      <img
                                        src={rightArrow}
                                        alt=""
                                        style={{ height: "22px", width: "22px" }}
                                      />
                                    </span>
                                  )}
                                </div>

                                <div className="v2-dash-overallpending-list">
                                  {loading ? (
                                    <ShimmerLoader />
                                  ) : !hasLearningContent ? (
                                    <div className="v2-dash-empty-state">
                                      <img
                                        src={emptyLearningImg}
                                        style={{
                                          width: "120px",
                                          height: "120px",
                                          objectFit: "contain",
                                        }}
                                        alt="No Learning Content"
                                        className="v2-dash-empty-image"
                                      />

                                      <div className="v2-dash-empty-title">
                                        No Learning Contents to complete
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      {uniquePendingItems
                                        .slice(0, 3)
                                        .map((item) => (
                                          <div
                                            key={item.id}
                                            className="v2-dash-overallpending-item"
                                          >
                                            <div className="v2-dash-overallpending-left">
                                              <img
                                                src={item.image}
                                                alt=""
                                                className="v2-dash-overallpending-icon"
                                              />

                                              <TruncatedTextWithTooltip
                                                text={item.title}
                                              />
                                            </div>

                                            <button
                                              className={`v2-dash-overallpending-btn ${item.action === "Resume"
                                                ? "v2-dash-overallpending-btn-blue"
                                                : ""
                                                }`}
                                              onClick={async () => {
                                                if (
                                                  item.program_category ===
                                                  "Industry"
                                                ) {
                                                  if (item.is_lab_session) {
                                                    await getLabTopicVideos(
                                                      item.course_id,
                                                      item.id,
                                                      item.topic_id,
                                                      item.program_id,
                                                    );
                                                  } else {
                                                    await getTopicVideos(
                                                      item.topic_id,
                                                      item.course_id,
                                                      item.program_id,
                                                      item.id,
                                                    );
                                                  }
                                                } else if (
                                                  item.program_category ===
                                                  "Jozuna"
                                                ) {
                                                  await getRecommendationTopicVideos(
                                                    item.topic_id,
                                                    item.course_id,
                                                    item.program_id,
                                                    item.id,
                                                  );
                                                } else {
                                                  await getTopicVideos(
                                                    item.topic_id,
                                                    item.course_id,
                                                    item.program_id,
                                                    item.id,
                                                  );
                                                }
                                              }}
                                            >
                                              {item.action}
                                            </button>
                                          </div>
                                        ))}

                                      {uniquePendingItems.length > 0 &&
                                        uniquePendingItems.length < 3 && (
                                          <div
                                            className="empty-engagement-placeholder"
                                            style={{
                                              height:
                                                uniquePendingItems.length === 1
                                                  ? "100px" // fills 1 missing card
                                                  : "50px", // fills 2 missing cards
                                            }}
                                          >
                                            <EmptyEngagementPlaceholder />
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}

                        {/* INTERACTIVE ACTIVITIES */}
                        {showInteractive && (
                          <div
                            className="v2-dash-overallpending-column"
                            style={{
                              width: "100%",
                              gridColumn: showBothColumnsForEmptyState
                                ? "auto"
                                : isSingleColumn
                                  ? "1 / -1"
                                  : "auto",
                            }}
                          >
                            <div
                              className="v2-dash-overallpending-card"
                              style={{ width: "100%" }}
                            >
                              <div className="v2-dash-overallpending-header">
                                <span>Interactive Activities</span>

                                {!loadingActive && hasActiveAssessments && (
                                  <span
                                    className="v2-dash-overallpending-view"
                                    onClick={() => {
                                      navigate("/dashboard/assessment");
                                    }}
                                  >
                                    Assessment Hub{" "}
                                    <img
                                      src={rightArrow}
                                      alt=""
                                      style={{ height: "22px", width: "22px" }}
                                    />
                                  </span>
                                )}
                              </div>

                              <div className="v2-dash-overallpending-list">
                                {loadingActive ? (
                                  <ShimmerLoader />
                                ) : !hasActiveAssessments ? (
                                  <div className="v2-dash-empty-state">
                                    <img
                                      src={emptyAssessmentImg}
                                      alt="No Activities"
                                      style={{
                                        width: "120px",
                                        height: "120px",
                                        objectFit: "contain",
                                      }}
                                      className="v2-dash-empty-image"
                                    />

                                    <div className="v2-dash-empty-title">
                                      No more interactive activities
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    {uniquePendingActiveItems
                                      .slice(0, 3)
                                      .map((item) => (
                                        <div
                                          key={item.id}
                                          style={{
                                            backgroundColor: "white",
                                          }}
                                          className="v2-dash-overallpending-item activity"
                                        >
                                          <div className="v2-dash-overallpending-left">
                                            <TruncatedTextWithTooltip
                                              text={item.title}
                                            />
                                          </div>

                                          <button
                                            className="v2-dash-overallpending-btn v2-dash-overallpending-btn-yellow"
                                            onClick={() =>
                                              handleAssessmentClick(item)
                                            }
                                          >
                                            {item.action}
                                          </button>
                                        </div>
                                      ))}

                                    {uniquePendingActiveItems.length > 0 &&
                                      uniquePendingActiveItems.length < 3 && (
                                        <div
                                          className="empty-engagement-placeholder"
                                          style={{
                                            height:
                                              uniquePendingActiveItems.length ===
                                                1
                                                ? "100px" // fills 1 missing card
                                                : "50px", // fills 2 missing cards
                                          }}
                                        >
                                          <EmptyEngagementPlaceholder />
                                        </div>
                                      )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="v2-dash-row-right">
                <MiniCalendar
                  calendarHeight="calc(100% - 85px)"
                  onDateSelect={(date) => {
                    console.log("Selected date:", date);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          {apiData &&
            (apiData.jozuna_score.length !== 0 ||
              apiData.curriculum_score.length !== 0 ||
              apiData.industry_score.length !== 0) && (
              <div className="v2-bottom-section">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    // marginBottom: "20px",
                  }}
                >
                  <div className="v2-tabs">
                    <p
                      style={{
                        fontFamily: "mazzard",
                        fontSize: "18px",
                        color: "#2d2d2d",
                        fontWeight: "700",
                        marginTop: "4px",
                      }}
                    >
                      Performance Report
                    </p>
                    {apiData.jozuna_score.length !== 0 && (
                      <button
                        className={activeTab === "jozuna" ? "v2-active" : ""}
                        style={{
                          cursor:
                            activeTab === "jozuna" ? "default" : "pointer",
                          transform:
                            activeTab === "jozuna" ? "scale(0.96)" : "scale(1)",
                        }}
                        onClick={() => setActiveTab("jozuna")}
                      >
                        Jozuna Skills ({apiData.jozuna_score.length})
                      </button>
                    )}

                    {apiData.curriculum_score.length !==
                      0 && (
                        <button
                          className={
                            activeTab === "curriculum" ? "v2-active" : ""
                          }
                          style={{
                            cursor:
                              activeTab === "curriculum" ? "default" : "pointer",
                            transform:
                              activeTab === "curriculum"
                                ? "scale(0.96)"
                                : "scale(1)",
                          }}
                          onClick={() => setActiveTab("curriculum")}
                        >
                          Curriculum (
                          {apiData.curriculum_score.length}
                          )
                        </button>
                      )}

                    {/* {apiData.industry_score.filter(
                      (item) => item.is_graded === true,
                    ).length !== 0 && ( */}
                    {apiData.industry_score.length !== 0 && (
                      <button
                        className={activeTab === "industry" ? "v2-active" : ""}
                        style={{
                          cursor:
                            activeTab === "industry" ? "default" : "pointer",
                          transform:
                            activeTab === "industry"
                              ? "scale(0.96)"
                              : "scale(1)",
                        }}
                        onClick={() => setActiveTab("industry")}
                      >
                        {profileData?.institute_name
                          ?.toLowerCase()
                          .includes("techbots")
                          ? `Pop-Quiz (${apiData.industry_score.filter(
                            (item) => item.is_graded === true,
                          ).length
                          })`
                          : `Professional (${apiData.industry_score.length})`}
                      </button>
                    )}
                  </div>

                  <div className="v2-actions">
                    {activeTab === "jozuna" && (
                      <button
                        className="v2-action-btnREC"
                        onClick={() => {
                          navigate("/dashboard/recommendation/jozunaview", {
                            state: {
                              title: "Jozuna Skill Recommendations",
                              heading: "Jozuna Skill Recommendations",
                              recommendationData: apiData.jozuna_score,
                            },
                          });
                        }}
                      >
                        Go to Recommendation
                        <img
                          src={arrowImg}
                          alt="arrow"
                          className="v2-btn-icon"
                        />
                      </button>
                    )}

                    <button
                      className="v2-action-btn"
                      onClick={() => {
                        if (activeTab === "jozuna") {
                          navigate("skills-details", {
                            state: {
                              title: "Jozuna Skills Performance",
                              heading: `Jozuna Skills (${apiData.jozuna_score.length})`,
                              chartData: apiData.jozuna_score,
                              toggleOptions: [
                                "Assessments Results",
                                "Skills Timeline",
                              ],
                              slidebarProgressOptions: [],
                              slidebarResultsOptions: [],
                            },
                          });

                          dispatch(setSelectedToggle("Assessments Results"));
                        }
                        if (activeTab === "curriculum") {
                          const curriculumData = [
                            ...apiData.curriculum_score,

                          ];

                          navigate("skills-details", {
                            state: {
                              title: "Curriculum Performance",
                              heading: `Curriculum (${curriculumData.length})`,
                              chartData: curriculumData,
                              is_graded_quiz: isGradedQuiz,
                              toggleOptions: [
                                "Assessments Results",
                                "Progress Timeline",
                              ],
                              slidebarProgressOptions: [
                                "Overall Progress",
                                "Concepts Performance",
                              ],
                              slidebarResultsOptions: [
                                "Overall Resul",
                                "View Concept Analytics",
                              ],
                            },
                          });
                          dispatch(setSelectedToggle("Assessments Results"));
                        }
                        if (activeTab === "industry") {
                          const isTechbots = profileData?.institute_name
                            ?.toLowerCase()
                            .includes("techbots");

                          // const professionalData =
                          //   apiData.industry_score.filter(
                          //     (item) => item.is_graded === true,
                          //   );
                          const professionalData = apiData.industry_score;

                          navigate("skills-details", {
                            state: {
                              title: "Program Performance",
                              heading: isTechbots
                                ? `Pop-Quiz (${professionalData.length})`
                                : `Professional (${professionalData.length})`,
                              chartData: professionalData,
                              is_graded_quiz: apiData.is_graded_quiz,
                              toggleOptions: isTechbots
                                ? ["Pop-Quiz"]
                                : [
                                  ...(profileData.partner_institute &&
                                    apiData.is_graded_quiz
                                    ? ["Pop-Quiz"]
                                    : []),
                                  "Assessments Results",
                                  "Progress Timeline",
                                ],
                              slidebarProgressOptions: [
                                "Overall Progress",
                                "Concepts Performance",
                              ],
                              slidebarResultsOptions: [
                                "Overall Results",
                                "View Concept Analytics",
                              ],
                            },
                          });
                          if (
                            isTechbots ||
                            (profileData.partner_institute &&
                              apiData.is_graded_quiz)
                          ) {
                            dispatch(setSelectedToggle("Pop-Quiz"));
                          } else {
                            dispatch(setSelectedToggle("Assessments Results"));
                          }
                        }
                      }}
                    >
                      Detailed Insights
                      <img src={arrowImg} alt="arrow" className="v2-btn-icon" />
                    </button>
                  </div>
                </div>

                <div className="skills-slider-wrapper">
                  {getCurrentData().length > 4 && (
                    <button
                      className="scroll-btn_v2 left"
                      onClick={scrollLeft}
                      disabled={!canScrollLeft}
                    >
                      <ChevronLeft />
                    </button>
                  )}
                  <div
                    className="v2-skills-grid"
                    ref={scrollRef}
                    onScroll={checkScroll}
                  >
                    {getCurrentData().map((item: DomainScore) => {
                      const styleInfo =
                        CommonUtils.getBgImgAndColorBasedProgressV2(
                          item.progress,
                        );

                      return (
                        <div key={item.domain_id} className="v2-skill-card">
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              alignItems: "center",
                            }}
                          >
                            {activeTab === "jozuna" && (
                              <img
                                src={getDomainImage(item.domain_name)}
                                alt={item.domain_name}
                                style={{ height: "30px", width: "30px" }}
                              />
                            )}
                            {item.domain_name.length > 52 ? (
                              <Tooltip
                                title={item.domain_name}
                                arrow
                                placement="top"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      bgcolor: "#2B2B2B",
                                      fontSize: "13px",
                                      fontFamily: "Mazzard",
                                      borderRadius: "8px",
                                    },
                                  },
                                }}
                              >
                                <span className="v2-skill-name">
                                  {item.domain_name}
                                </span>
                              </Tooltip>
                            ) : (
                              <span className="v2-skill-name">
                                {item.domain_name}
                              </span>
                            )}{" "}
                          </div>
                          <div
                            style={{
                              gap: "5px",
                              display: "flex",
                              alignItems: "center",
                              marginLeft: "10px",
                            }}
                          >
                            {item.progress !== null && (
                              <img
                                src={styleInfo?.trendImg}
                                alt="trend"
                                style={{ height: "30px", width: "30px" }}
                              />
                            )}
                            <span
                              className="performanceCardScoreV2"
                              style={{ color: styleInfo?.fontColor }}
                            >
                              {item.score}%
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {getCurrentData().length > 4 && (
                    <button
                      className="scroll-btn_v2 right"
                      onClick={scrollRight}
                      disabled={!canScrollRight}
                    >
                      <ChevronRight />
                    </button>
                  )}
                </div>
              </div>
            )}

          {showAll && (
            <div className="v2-overlay" onClick={() => setShowAll(false)}>
              <div
                className="v2-overlay-content"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="v2-events-header">
                  <h4>Upcoming Events</h4>
                  <img
                    src={closeIcon}
                    style={{ height: "40px", width: "40px", cursor: "pointer" }}
                    onClick={() => {
                      setShowAll(false);
                    }}
                  />
                </div>

                {events.map((item) => (
                  <div key={item.id} className={`v2-event v2-${item.type}`}>
                    <div>
                      <p className="upComingCourseName">{item.courseName}</p>
                      <p className="upComingEventname">{item.eventName}</p>

                      <div className="evetTimingsStyle">
                        <img
                          src={
                            item.type === "purple" ? calendar : sandClockStart
                          }
                        />
                        <p>{item.startDate}</p>

                        <img
                          src={item.type === "purple" ? clockImg : sandClockEnd}
                        />
                        <p>{item.endDate}</p>
                      </div>
                    </div>

                    <div className="eventBtnStyle">
                      <button
                        style={{
                          border:
                            item.type === "purple"
                              ? "1px solid #DDBDED"
                              : "1px solid #E2D198",
                        }}
                      >
                        {item.action}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <CardBottomOverlay
            isOpen={isLevelOpen}
            onClose={() => {
              setIsLevelOpen(false);
            }}
            cardHeight="80vh"
            cardWidth="90%"
          >
            <div className="v2-levelEngagementHeader">
              <div className="v2-levelEngagementHeader1">
                Level Up Your Engagement!{" "}
              </div>
              <div className="v2-levelEngagementHeader2">
                You are in the top 15% of students this month. Keep it up!
              </div>
            </div>
            <div className="dashboard-divider" style={{ marginTop: "20px" }} />
            <LevelUpEngagementComponent />
          </CardBottomOverlay>
          <CardBottomOverlay
            isOpen={isOverlayOpen}
            onClose={() => setIsOverlayOpen(false)}
            cardWidth={"40%"}
            cardHeight={"40%"}
          >
            <div className="engagementHeader">
              <h2 className="engagementHeader-title">Steps to achieve </h2>
            </div>
            <div className="dashboard-divider" style={{ marginTop: "20px" }} />
            <OverallProgressListPendingItems
              overallprogressvalue={
                apiData.overall_progress > 100 ? 100 : apiData.overall_progress
              }
              isAssessment={assessmentClicked}
            ></OverallProgressListPendingItems>
          </CardBottomOverlay>

          <CardBottomOverlay
            isOpen={openOverLay}
            onClose={() => setOpenOverlay(false)}
            cardWidth={"55%"}
            cardHeight={"40%"}
          >
            <div className="engagementHeader">
              <div className="engagementHeader-title">How To Step Up?</div>
              {/* <div>
            You are in the top {apiData.engagement_score.score} of students this
            month. Keep it up!
          </div> */}
            </div>
            <div className="dashboard-divider" style={{ marginTop: "20px" }} />

            <div className="v2-levelCardGrid">
              {cardDetails.map((card, index) => (
                <div
                  key={index}
                  className="v2-levelEngagementCard"
                  style={{ backgroundColor: card.bg }}
                >
                  <div className="v2-levelCardTop">
                    <img src={card.icon} alt="icon" className="v2-levelIcon" />

                    <div>
                      <h3 className="v2-levelTitle">{card.title}</h3>
                      <p className="v2-levelDesc">{card.desc}</p>
                    </div>
                  </div>

                  <button
                    className="v2-levelActionBtn"
                    onClick={() => {
                      if (card.button === "Take Assessment") {
                        navigate("/dashboard/assessment");
                      } else {
                        navigate("/dashboard/learning-room");
                      }
                    }}
                  >
                    {card.button}
                  </button>
                </div>
              ))}
            </div>
          </CardBottomOverlay>

          <CardBottomOverlay
            isOpen={feedbackOpenOverLay}
            onClose={() => {
              setFeedbackOpenOverLay(false);
            }}
            cardWidth={"35%"}
            cardHeight={"50%"}
          >
            <div className="v2-dashboard-feedback-container">
              <div
                className="v2-dashboard-feedback-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span
                  className="v2-dashboard-feedback-title"
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#101828",
                    fontFamily: "Mazzard",
                  }}
                >
                  Last 3 feedbacks
                </span>
              </div>

              <div className="dashboard-divider" />

              {loading ? (
                <div className="v2-dashboard-feedback-loading">
                  Loading feedbacks...
                </div>
              ) : previousFeedback.length > 0 ? (
                <div className="v2-dashboard-feedback-scroll">
                  {(() => {
                    let newestFeedbackId = "";
                    if (previousFeedback.length > 0) {
                      let maxTime = 0;
                      previousFeedback.forEach((item) => {
                        const time = new Date(
                          item.feedback_posted_time,
                        ).getTime();
                        if (time > maxTime) {
                          maxTime = time;
                          newestFeedbackId = item.feedback_id;
                        }
                      });
                    }

                    return previousFeedback.map((feedback, index) => {
                      const senderName =
                        feedback.institute_name || "Institute Dev";
                      const senderRole = feedback.role_name || "Admin";
                      const isNewest =
                        feedback.feedback_id === newestFeedbackId ||
                        (newestFeedbackId === "" && index === 0);

                      return (
                        <div
                          key={feedback.feedback_id || index}
                          className="v2-dashboard-feedback-item"
                        >
                          <div className="v2-dashboard-feedback-user-row">
                            <div className="v2-dashboard-feedback-avatar">
                              {getInitials(senderName)}
                            </div>

                            <div className="v2-dashboard-feedback-user-content">
                              <div className="v2-dashboard-feedback-user-header">
                                <span className="v2-dashboard-feedback-name">
                                  {senderName}
                                </span>

                                <span className="v2-dashboard-feedback-role">
                                  {senderRole}
                                </span>

                                <span className="v2-dashboard-feedback-date">
                                  {isNewest && (
                                    <span className="v2-dashboard-feedback-unread-dot">
                                      •
                                    </span>
                                  )}
                                  {formatDate(feedback.feedback_posted_time)}
                                </span>
                              </div>

                              <div className="v2-dashboard-feedback-message-wrapper">
                                {renderFeedbackMessage(
                                  feedback.feedback_message,
                                  feedback,
                                  handleResourceClick,
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    });
                  })()}
                </div>
              ) : (
                <div className="v2-dashboard-feedback-empty-state">
                  <p>No feedback available</p>
                </div>
              )}
            </div>
          </CardBottomOverlay>

          <DashboardNeedHelp
            isOpen={isModalOpen}
            toggleModal={needHelptoggleModal}
          />
        </div>
      </div>
    </div>
  );
}

export default DashboardPage;
